export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00942.4afb2da9.png";